import { createSelector } from '@ngrx/store';
import { OrganizationModels } from '@share-models';
import { organizationFeature } from './organization.feature';

export const selectArchiveDurationLimit = createSelector(
  organizationFeature.selectActiveOrganization,
  (organization) => organization?.settings.archiveLimitDuration,
);

export function isOrganizationChatAvailable(
  organization: OrganizationModels.UserOrganizationDropDown,
): boolean {
  return (
    organization.chatStatus === true && Boolean(organization.synapseSpaceId)
  );
}

export const selectActiveOrganizationChatStatus = createSelector(
  organizationFeature.selectActiveOrganization,
  (organization) => organization?.settings.chatStatus,
);
export const selectActiveOrganizationSynapseSpaceId = createSelector(
  organizationFeature.selectActiveOrganization,
  (organization) => organization?.settings.synapseSpaceId,
);

export const selectUserOrganizationCount = createSelector(
  organizationFeature.selectUserOrganizations,
  (organizations) => organizations.length,
);

export const selectHasAvailableChatOrganization = createSelector(
  organizationFeature.selectUserOrganizations,
  (organizations) => organizations.some(isOrganizationChatAvailable),
);
